// Material Kit 2 React pages
import EventVideos from "pages/EventVideos";

export default function EventVideosPage() {
  return <EventVideos />;
}
